import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import User from "../../assets/icons/user.svg";
import Logout from "../../assets/icons/logout.svg";
import styles from "./navigationBar.module.css";
import { useUser } from "../../context/UserContext";
import { useMantenedora } from "../../context/MantenedoraContext";
import { useInstitution } from "../../context/InstitutionContext";
import { getCookie, clearSession } from "../../utils/cookies";
import { readUserById } from "../../services/academetrics";

const NavigationBar = React.forwardRef((props, ref) => {
  const navigate = useNavigate();
  const { user, setUser, clearUser } = useUser();
  const { clearMantenedora } = useMantenedora();
  const { setInstitution } = useInstitution();

  // Busca dados do usuário apenas se não tiver no contexto e estiver logado
  useEffect(() => {
    const fetchUserIfNeeded = async () => {
      if (user) return; // Já tem dados no contexto

      const token = getCookie("token");
      if (!token) return; // Não está logado

      try {
        const decoded = jwtDecode(token);
        const userId = decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"] 
          || decoded["sub"] 
          || decoded["userId"]
          || decoded["nameid"];

        if (userId) {
          const userData = await readUserById(userId);
          if (userData) {
            setUser(userData);
          }
        }
      } catch (error) {
        console.log("Erro ao buscar dados do usuário:", error);
      }
    };

    fetchUserIfNeeded();
  }, [user, setUser]);

  const handleLogout = () => {
    clearUser();
    clearMantenedora();
    setInstitution({});
    clearSession();
    navigate("/auth/login");
  };

  const handleProfile = () => {
    navigate("/app/meu-perfil");
  };

  const getUserDisplayName = () => {
    if (user?.firstName) {
      return user.firstName;
    }
    if (user?.email) {
      return user.email;
    }
    return "Meu Perfil";
  };

  return (
    <ul className={styles.navigationBar} ref={ref}>
      <li onClick={handleProfile} className={styles.profileItem}>
        <img src={User} alt="User" />
        <span>{getUserDisplayName()}</span>
      </li>
      <li onClick={handleLogout}>
        <img src={Logout} alt="Logout" />
        <span>Logout</span>
      </li>
    </ul>
  );
});

export default NavigationBar;
